module.exports = __webpack_public_path__ + "static/img/200133.b88488f4.png";